import type { WidgetState } from "@/context/tabs/types";
import type { ViewId } from "@/shared/types/common";

let lastClickTime = 0;
const DOUBLE_CLICK_DELAY = 300; // milliseconds

export function updateLinkedTiles(
	event: React.MouseEvent<Element, MouseEvent>,
	state: WidgetState | undefined,
	setWidgetState: (widgetId: ViewId, data: Partial<WidgetState>) => void,
	tileId: string,
	setClickInfo: (v: Record<string, string>) => void,
	oneClickTrigger: boolean,
	onTickerSelect?: (ticker: string) => void,
) {
	const currentTime = Date.now();
	const isDoubleClick = currentTime - lastClickTime < DOUBLE_CLICK_DELAY;
	lastClickTime = currentTime;

	const ticker = (event.currentTarget as HTMLElement).dataset.rowId as string;

	const updateTiles = () => {
		setWidgetState(tileId as ViewId, { ...(state || {}), ticker: ticker });
		setClickInfo({ [tileId]: ticker });
	};

	if (oneClickTrigger) {
		if (!isDoubleClick) {
			setTimeout(() => {
				if (currentTime === lastClickTime) {
					updateTiles();
				}
			}, DOUBLE_CLICK_DELAY);
		}
		return;
	}

	if (isDoubleClick) {
		updateTiles();
	}

	if (ticker) {
		onTickerSelect?.(ticker);
	}
}
